import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Alert } from '@mui/material';
import notaFiscalService from '../../../services/notaFiscalService';

const ModalBaixarNota = ({ open, onClose, numeroNota, compraId, onDownload }) => {
  const [baixando, setBaixando] = useState(false);
  const [erro, setErro] = useState('');

  const handleDownload = async () => {
    if (!compraId) {
      setErro('ID da compra não encontrado.');
      return;
    }

    setBaixando(true);
    setErro('');

    try {
      // Chame o novo método para abrir em nova guia
      await notaFiscalService.abrirNotaFiscalEmNovaGuia(compraId);

      // Chamar callback se fornecido
      if (onDownload) {
        onDownload();
      }
    } catch (error) {
     // console.error('Erro ao baixar nota fiscal:', error);
      const errorMessage = error.response?.data?.message || 'Erro ao baixar nota fiscal. Tente novamente.';
      setErro(errorMessage);
    } finally {
      setBaixando(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Baixar Nota Fiscal</DialogTitle>
      <DialogContent>
        {erro && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {erro}
          </Alert>
        )}
        
        <Box mb={2}>
          <Typography variant="subtitle2" color="text.secondary">
            Nº da Nota Fiscal:
          </Typography>
          <Typography variant="h6" color="text.primary" sx={{ mb: 2 }}>
            {numeroNota || '---'}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={baixando}>
          Cancelar
        </Button>
        <Button 
          onClick={handleDownload} 
          color="primary" 
          variant="contained"
          disabled={baixando}
        >
          {baixando ? 'Baixando...' : 'Baixar PDF'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalBaixarNota; 